import { AddToCartFormProps } from "../components/addToCartForm/addToCartForm.models";

/**
 * A utility class for mapping HTML element dataset attribute string values to typed props.
 */
export default class PropsMapper {
    static addToCartFormProps = (el: HTMLElement): AddToCartFormProps => {
        return {
            matrixSizes: JSON.parse(el.dataset.matrixSizesJson || "{}"),
            regularSizes: el.dataset.regularSizesJson
                ? JSON.parse(el.dataset.regularSizesJson)
                : {},
            shopId: el.dataset.shopId || "",
            isSizeGuide: el.dataset.isSizeGuide === "True",
            isProductInStock: el.dataset.isProductInStock === "True",
            productAvailableInStore:
                el.dataset.productAvailableInStore === "True",
            displayName: el.dataset.displayName || "",
            itemColor: el.dataset.itemColor || "",
            itemMetaColor: el.dataset.itemMetaColor || "",
            cartStatusImage: el.dataset.cartStatusImage || "",
            checkoutLink: el.dataset.checkoutLink || "",
            esalesKey: el.dataset.esalesKey || "",
            showAvailability: true,
            showInventoryNotification: el.dataset.showInventoryNotification === "true",
            categoryName: el.dataset.categoryName || "",
            clickAndCollectEnabled: el.dataset.clickAndCollectEnabled === "true",
        };
    };
}
